import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../store/indexRedux';
import { setSystemTheme } from '../store/themeSlice';

export const useTheme = () => {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useSelector((state: RootState) => state.theme.theme);
  const systemThemeActivated = useSelector((state: RootState) => state.theme.systemThemeActivated);

  // Set initial theme based on localStorage or default theme
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const currentTheme = savedTheme || 'mytheme';

    document.documentElement.setAttribute('data-theme', currentTheme);

    if (currentTheme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    if (!savedTheme) {
      localStorage.setItem('theme', currentTheme);
    }
  }, []);

  // Update document theme based on state
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);

    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    localStorage.setItem('theme', theme);
  }, [theme]);

  // Handle system theme changes
  useEffect(() => {
    if (systemThemeActivated) {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

      dispatch(setSystemTheme(prefersDark.matches ? 'dark' : 'mytheme'));

      const handleSystemThemeChange = (e: MediaQueryListEvent) => {
        const newTheme = e.matches ? 'dark' : 'mytheme';
        dispatch(setSystemTheme(newTheme));
      };

      prefersDark.addEventListener('change', handleSystemThemeChange);

      return () => {
        prefersDark.removeEventListener('change', handleSystemThemeChange);
      };
    }
  }, [dispatch, systemThemeActivated]);
};
